import { HttpInterceptorFn } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { KeycloakAuthService } from '../auth/keycloak-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(KeycloakAuthService);

  const withAuth = (token: string | null) => {
    if (!token) {
      return req;
    }
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  };

  return from(auth.getValidAccessToken()).pipe(
    switchMap((token) => next(withAuth(token)).pipe(
      catchError((err: unknown) => {
        if (!(err instanceof HttpErrorResponse) || err.status !== 401) {
          return throwError(() => err);
        }
        return from(auth.refreshSession()).pipe(
          switchMap((refreshed) => {
            if (!refreshed) {
              return throwError(() => err);
            }
            return next(withAuth(auth.getStoredAccessToken()));
          }),
          catchError(() => throwError(() => err))
        );
      })
    ))
  );
};
